// src/components/chat/toolDisplay.ts
// Shared tool display metadata for rendering tool segments as pills.

import React from 'react';
import {
  Database,
  Brain,
  BookOpen,
  FileEdit,
  FilePlus,
  Wrench,
  BarChart3,
  FileCode,
  Palette,
  Code2,
  FileUp,
} from 'lucide-react';

export interface ToolDisplayInfo {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const TOOL_DISPLAY: Record<string, ToolDisplayInfo> = {
  query_aggregated_metrics: { icon: Database, label: 'Querying metrics' },
  query_raw_transactions: { icon: Database, label: 'Querying transactions' },
  get_account_schema: { icon: Database, label: 'Loading schema' },
  get_memories: { icon: Brain, label: 'Recalling context' },
  add_memory: { icon: Brain, label: 'Saving context' },
  get_wiki_index: { icon: BookOpen, label: 'Reading knowledge base' },
  get_wiki_page: { icon: BookOpen, label: 'Reading wiki page' },
  create_wiki_page: { icon: FilePlus, label: 'Creating wiki page' },
  edit_wiki_page: { icon: FileEdit, label: 'Editing wiki page' },
  create_dashboard_block: { icon: BarChart3, label: 'Creating dashboard block' },
  update_dashboard_block: { icon: BarChart3, label: 'Updating dashboard block' },
  remove_dashboard_block: { icon: BarChart3, label: 'Removing dashboard block' },
  set_dashboard_settings: { icon: Palette, label: 'Updating dashboard settings' },
  generate_artifact: { icon: FileCode, label: 'Generating artifact' },
  execute_python: { icon: Code2, label: 'Running code' },
  promote_artifact: { icon: FileUp, label: 'Promoting artifact' },
};

export function getToolDisplay(toolName: string): ToolDisplayInfo {
  return TOOL_DISPLAY[toolName] ?? { icon: Wrench, label: toolName };
}
